export default __webpack_public_path__ + "static/media/loopQ.96fc70ba.jpg";